<script>
  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /**
   * @type {PageSelector} props - The component props.
   */

  export let pageNumber;
  export let current = false;
  export let arialLabel = null;
  export let hasPopup = false;
  export let expanded = false;

  $: classFocus = `focus-visible:outline-dashed focus-visible:outline-black focus-visible:outline-offset-0 focus-visible:outline-[2px] ${
    current && "focus-visible:outline-cobalt-blue"
  }`;
  $: classUnderline = `transition-colors block w-6 h-1 mt-[0.7rem] ${current && "bg-cobalt-blue"}`;

  $: classButtonActive = `${current && "text-cobalt-blue"}`;
</script>

<div class="flex flex-col justify-between">
  <button
    class="group relative pt-[0.69rem] transition-colors hover:text-cobalt-blue {classFocus} {classButtonActive}"
    on:click
    {id}
    aria-label={arialLabel}
    aria-haspopup={hasPopup}
    aria-expanded={hasPopup ? expanded : null}
  >
    {pageNumber}
    <span class={classUnderline} />
  </button>
</div>
